import { FeatureFlag, RouteName, TextKey } from '@mews-commander/enums';
import { useFeatureFlag } from '@mews/framework';
import { canCurrentProfileViewSensitiveReports } from '@mews-commander/legacy-entities/src/selectors/session/scope';
import { useCommanderSelector } from '@mews-commander/utils';
import { useNavigationSearchResult } from './useNavigationSearchResult';
import { AssistantNavigation } from './AssistantNavigation';

export const useBusinessIntelligenceNavigation = (): AssistantNavigation[] => {
    const dashboardsListResult = useNavigationSearchResult(
        RouteName.BusinessIntelligenceIndex,
        TextKey.MewsBusinessIntelligence,
        {}
    );

    const canViewSensitiveReports = useCommanderSelector(canCurrentProfileViewSensitiveReports);
    const BIEnabled = useFeatureFlag(FeatureFlag.insightsEnabled);

    if (!canViewSensitiveReports || !BIEnabled) return [];

    return [dashboardsListResult];
};
